import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "nav-scroll" }
const _hoisted_3 = { class: "identity-block warehouse-identity-block" }
const _hoisted_4 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0","opacity":".7"}
}
const _hoisted_5 = {
  class: "nav-group",
  style: {"margin-top":"4px"}
}
const _hoisted_6 = { class: "nav-links" }
const _hoisted_7 = { class: "nav-group" }
const _hoisted_8 = { class: "nav-links" }
const _hoisted_9 = { class: "nav-group" }
const _hoisted_10 = { class: "nav-links" }
const _hoisted_11 = { class: "identity-block office-identity-block" }
const _hoisted_12 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0","opacity":".7"}
}
const _hoisted_13 = {
  class: "nav-group",
  style: {"margin-top":"4px"}
}
const _hoisted_14 = { class: "nav-links" }
const _hoisted_15 = { class: "nav-group" }
const _hoisted_16 = { class: "nav-links" }
const _hoisted_17 = { class: "nav-group" }
const _hoisted_18 = { class: "nav-links" }
const _hoisted_19 = { class: "nav-group" }
const _hoisted_20 = { class: "nav-links" }
const _hoisted_21 = { class: "nav-group" }
const _hoisted_22 = { class: "nav-links" }
const _hoisted_23 = { class: "identity-block maint-identity-block" }
const _hoisted_24 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0","opacity":".7"}
}
const _hoisted_25 = {
  class: "nav-group",
  style: {"margin-top":"4px"}
}
const _hoisted_26 = { class: "nav-links" }
const _hoisted_27 = { class: "identity-block portaria-identity-block" }
const _hoisted_28 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0","opacity":".7"}
}
const _hoisted_29 = {
  class: "nav-group",
  style: {"margin-top":"4px"}
}
const _hoisted_30 = { class: "nav-links" }
const _hoisted_31 = { class: "identity-block" }
const _hoisted_32 = {
  key: 1,
  class: "project-label"
}
const _hoisted_33 = { class: "project-label-text" }
const _hoisted_34 = {
  key: 2,
  class: "panel-title-label"
}
const _hoisted_35 = {
  key: 3,
  class: "nav-group"
}
const _hoisted_36 = { class: "nav-group-header" }
const _hoisted_37 = { class: "nav-links" }
const _hoisted_38 = {
  key: 4,
  class: "admin-hub"
}
const _hoisted_39 = {
  class: "nav-group",
  style: {"margin-top":"4px"}
}
const _hoisted_40 = { class: "nav-links" }
const _hoisted_41 = {
  key: 0,
  class: "ticket-badge"
}
const _hoisted_42 = {
  key: 0,
  class: "nav-group"
}
const _hoisted_43 = { class: "nav-group-header nav-group-header--mode" }
const _hoisted_44 = {
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  style: {"opacity":".5"}
}
const _hoisted_45 = { class: "nav-links" }
const _hoisted_46 = {
  key: 1,
  class: "nav-group"
}
const _hoisted_47 = { class: "nav-group-header nav-group-header--mode" }
const _hoisted_48 = {
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  style: {"opacity":".5"}
}
const _hoisted_49 = { class: "nav-links" }
const _hoisted_50 = {
  key: 2,
  class: "nav-group"
}
const _hoisted_51 = { class: "nav-group-header nav-group-header--mode" }
const _hoisted_52 = {
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  style: {"opacity":".5"}
}
const _hoisted_53 = { class: "nav-links" }
const _hoisted_54 = {
  key: 3,
  class: "nav-group"
}
const _hoisted_55 = { class: "nav-group-header nav-group-header--mode" }
const _hoisted_56 = {
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  style: {"opacity":".5"}
}
const _hoisted_57 = { class: "nav-links" }
const _hoisted_58 = {
  key: 5,
  class: "nav-group",
  style: {"margin-top":"4px"}
}
const _hoisted_59 = { class: "nav-group-header" }
const _hoisted_60 = { class: "nav-links" }
const _hoisted_61 = {
  key: 0,
  class: "ticket-badge"
}
const _hoisted_62 = { class: "mode-toggle" }
const _hoisted_63 = { class: "sidebar-user-name" }
const _hoisted_64 = {
  key: 0,
  class: "msg-badge"
}
const _hoisted_65 = {
  key: 1,
  class: "mode-menu"
}
const _hoisted_66 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_67 = {
  key: 0,
  class: "mode-check",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_68 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_69 = {
  key: 0,
  class: "mode-check",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_70 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_71 = {
  key: 0,
  class: "mode-check",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_72 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_73 = {
  key: 0,
  class: "mode-check",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_74 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_75 = {
  key: 0,
  class: "mode-check",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_76 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_77 = {
  key: 0,
  class: "mode-check",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_78 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_79 = {
  key: 1,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_80 = {
  key: 2,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_81 = {
  key: 3,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_82 = {
  key: 4,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_83 = {
  key: 5,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0"}
}
const _hoisted_84 = {
  class: "chevron-icon",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0","margin-left":"auto"}
}
const _hoisted_85 = {
  key: 3,
  class: "analyst-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardSearchBox = _resolveComponent("DashboardSearchBox")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showSearch)
        ? (_openBlock(), _createBlock(_component_DashboardSearchBox, {
            key: 0,
            class: "sidebar-search",
            "model-value": _ctx.searchQuery,
            "white-on-mobile": true,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('search-change', $event))),
            onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search-submit')))
          }, null, 8, ["model-value"]))
        : _createCommentVNode("", true),
      (_ctx.warehouseMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.isAnalyst)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "create-btn create-btn--warehouse",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('open-create-popup')))
                }, [...(_cache[66] || (_cache[66] = [
                  _createElementVNode("span", { class: "create-icon" }, "+", -1),
                  _createTextVNode(" Criar ", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[67] || (_cache[67] = [
                _createElementVNode("path", { d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" }, null, -1)
              ]))])),
              _cache[68] || (_cache[68] = _createTextVNode(" Almoxarifado ", -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[69] || (_cache[69] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Estoque")
              ], -1)),
              _createElementVNode("nav", _hoisted_6, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.isWarehouseTab('estoque') }]),
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('warehouse-stock')))
                }, " Inventário ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.isWarehouseTab('solicitacoes') }]),
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('warehouse-requests')))
                }, " Solicitações ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.isWarehouseTab('planejamento') }]),
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('warehouse-planejamento')))
                }, " Planejamento ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/almoxarifado/avarias') }]),
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('warehouse-avarias')))
                }, " Avarias ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[70] || (_cache[70] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Operações")
              ], -1)),
              _createElementVNode("nav", _hoisted_8, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/almoxarifado/importar-nf') }]),
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('warehouse-nfe-import')))
                }, " Importar NF ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/almoxarifado/solicitar-item') }]),
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('warehouse-request-item')))
                }, " Solicitar Item ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[71] || (_cache[71] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Frota")
              ], -1)),
              _createElementVNode("nav", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/maquinario-pesado') }]),
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('heavy-machinery')))
                }, " Maquinário Pesado ", 2)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.officeMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (!_ctx.isAnalyst)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "create-btn create-btn--office",
                  type: "button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('open-create-popup')))
                }, [...(_cache[72] || (_cache[72] = [
                  _createElementVNode("span", { class: "create-icon" }, "+", -1),
                  _createTextVNode(" Criar ", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[73] || (_cache[73] = [
                _createElementVNode("rect", {
                  x: "2",
                  y: "7",
                  width: "20",
                  height: "14",
                  rx: "2"
                }, null, -1),
                _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }, null, -1)
              ]))])),
              _cache[74] || (_cache[74] = _createTextVNode(" Escritório ", -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[75] || (_cache[75] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Cadastros")
              ], -1)),
              _createElementVNode("nav", _hoisted_14, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.officeTab === 'fornecedores' }]),
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('office-tab', 'fornecedores')))
                }, " Fornecedores ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[76] || (_cache[76] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Compras")
              ], -1)),
              _createElementVNode("nav", _hoisted_16, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.officeTab === 'rc' }]),
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('office-tab', 'rc')))
                }, " Req. de Compra ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.officeTab === 'oc' }]),
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('office-tab', 'oc')))
                }, " Ordens de Compra ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[77] || (_cache[77] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Financeiro")
              ], -1)),
              _createElementVNode("nav", _hoisted_18, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.officeTab === 'nf' }]),
                  type: "button",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('office-tab', 'nf')))
                }, " Notas Fiscais ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.officeTab === 'cc' }]),
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('office-tab', 'cc')))
                }, " Centro de Custo ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[78] || (_cache[78] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Treinamento")
              ], -1)),
              _createElementVNode("nav", _hoisted_20, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.officeTab === 'questionarios' }]),
                  type: "button",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('office-tab', 'questionarios')))
                }, " Questionários ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[79] || (_cache[79] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Configurações")
              ], -1)),
              _createElementVNode("nav", _hoisted_22, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.officeTab === 'gerencia' }]),
                  type: "button",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('office-tab', 'gerencia')))
                }, " Gerenciar Escritório ", 2)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.maintenanceMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("button", {
              class: "create-btn create-btn--maintenance",
              type: "button",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('open-create-popup')))
            }, [...(_cache[80] || (_cache[80] = [
              _createElementVNode("span", { class: "create-icon" }, "+", -1),
              _createTextVNode(" Criar ", -1)
            ]))]),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[81] || (_cache[81] = [
                _createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" }, null, -1)
              ]))])),
              _cache[82] || (_cache[82] = _createTextVNode(" Manutenção ", -1))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[84] || (_cache[84] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Geral")
              ], -1)),
              _createElementVNode("nav", _hoisted_26, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/manutencao' }]),
                  type: "button",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('maintenance')))
                }, " Visão Geral ", 2),
                (_ctx.canAssignMaintenance)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/manutencao/ordens-servico' }]),
                      type: "button",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('maintenance-service-orders')))
                    }, " Gerenciar OS ", 2))
                  : _createCommentVNode("", true),
                (_ctx.canAssignMaintenance)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/manutencao/consultar-os' }]),
                      type: "button",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('maintenance-os-consulta')))
                    }, " Consultar OS ", 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link nav-link--manuais", { active: _ctx.activePath === '/manutencao/manuais' }]),
                  type: "button",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('maintenance-manuals')))
                }, [...(_cache[83] || (_cache[83] = [
                  _createTextVNode(" Manuais ", -1),
                  _createElementVNode("span", { class: "nav-beta-badge" }, "Beta", -1)
                ]))], 2)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.portariaMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(), _createElementBlock("svg", _hoisted_28, [...(_cache[85] || (_cache[85] = [
                _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" }, null, -1),
                _createElementVNode("path", { d: "M9 22V12h6v10" }, null, -1)
              ]))])),
              _cache[86] || (_cache[86] = _createTextVNode(" Portaria ", -1))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[87] || (_cache[87] = _createElementVNode("div", { class: "nav-group-header" }, [
                _createElementVNode("span", null, "Geral")
              ], -1)),
              _createElementVNode("nav", _hoisted_30, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/portaria' }]),
                  type: "button",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('go-portaria')))
                }, " Visão Geral ", 2)
              ])
            ])
          ], 64))
        : (!_ctx.warehouseMode && !_ctx.officeMode && !_ctx.maintenanceMode && !_ctx.portariaMode)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              (!_ctx.isAnalyst)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "create-btn",
                    type: "button",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('open-create-popup')))
                  }, [...(_cache[88] || (_cache[88] = [
                    _createElementVNode("span", { class: "create-icon" }, "+", -1),
                    _createTextVNode(" Criar ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.systemName), 1),
              (_ctx.projectName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[89] || (_cache[89] = _createElementVNode("svg", {
                      class: "project-icon",
                      width: "12",
                      height: "12",
                      viewBox: "0 0 12 12",
                      fill: "none"
                    }, [
                      _createElementVNode("rect", {
                        x: "1",
                        y: "1",
                        width: "10",
                        height: "10",
                        rx: "2",
                        stroke: "currentColor",
                        "stroke-width": "1.4"
                      }),
                      _createElementVNode("path", {
                        d: "M4 4h4M4 6h4M4 8h2",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round"
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.projectName), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.panelTitle && !_ctx.projectName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.panelTitle), 1))
                : _createCommentVNode("", true),
              (_ctx.isAnalyst)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('nav.dashboard')), 1)
                    ]),
                    _createElementVNode("nav", _hoisted_37, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/visao-geral' || _ctx.activePath === '/home' }]),
                        type: "button",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('overview')))
                      }, _toDisplayString(_ctx.$t('nav.overview')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/consulta-documentos' }]),
                        type: "button",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('documents')))
                      }, _toDisplayString(_ctx.$t('nav.viewDocuments')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/gerenciar-projetos' }]),
                        type: "button",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$emit('projects')))
                      }, _toDisplayString(_ctx.$t('nav.viewProjects')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/gerenciar-usuarios' }]),
                        type: "button",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$emit('users')))
                      }, _toDisplayString(_ctx.$t('nav.viewUsers')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/almoxarifado') }]),
                        type: "button",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('warehouse-stock')))
                      }, _toDisplayString(_ctx.$t('nav.viewWarehouse')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/maquinario-pesado') }]),
                        type: "button",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$emit('heavy-machinery')))
                      }, _toDisplayString(_ctx.$t('nav.viewMachinery')), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAdmin && !_ctx.isAnalyst && _ctx.adminMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[91] || (_cache[91] = _createElementVNode("div", { class: "nav-group-header" }, [
                        _createElementVNode("span", null, "Administração")
                      ], -1)),
                      _createElementVNode("nav", _hoisted_40, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/visao-geral' || _ctx.activePath === '/home' }]),
                          type: "button",
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.$emit('overview')))
                        }, " Visão Geral ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/gerenciar-projetos' }]),
                          type: "button",
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$emit('projects')))
                        }, " Gerenciar Projetos ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/gerenciar-usuarios' }]),
                          type: "button",
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.$emit('users')))
                        }, " Usuários ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/consulta-documentos' }]),
                          type: "button",
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.$emit('documents')))
                        }, " Documentos ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/chamados') }]),
                          type: "button",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.$emit('tickets')))
                        }, [
                          _cache[90] || (_cache[90] = _createTextVNode(" Chamados ", -1)),
                          (_ctx.ticketPendingCount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.ticketBadgeText), 1))
                            : _createCommentVNode("", true)
                        ], 2),
                        (_ctx.isMasterAdmin)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/gerenciar-sistema' }]),
                              type: "button",
                              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.$emit('system')))
                            }, " Configurar Sistema ", 2))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.canManageConstruction)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _cache[93] || (_cache[93] = _createElementVNode("span", null, "Construção", -1)),
                            (_openBlock(), _createElementBlock("svg", _hoisted_44, [...(_cache[92] || (_cache[92] = [
                              _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                            ]))]))
                          ]),
                          _createElementVNode("nav", _hoisted_45, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/meus-projetos' }]),
                              type: "button",
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.$emit('my-projects')))
                            }, " Meus Projetos ", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/meus-relatorios' }]),
                              type: "button",
                              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.$emit('filter', '')))
                            }, " Relatórios ", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/desenhos' }]),
                              type: "button",
                              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.$emit('drawings')))
                            }, " Desenhos ", 2)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canManageMaintenance)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _cache[95] || (_cache[95] = _createElementVNode("span", null, "Manutenção", -1)),
                            (_openBlock(), _createElementBlock("svg", _hoisted_48, [...(_cache[94] || (_cache[94] = [
                              _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                            ]))]))
                          ]),
                          _createElementVNode("nav", _hoisted_49, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/manutencao' }]),
                              type: "button",
                              onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.$emit('maintenance')))
                            }, " Visão Geral ", 2)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canManageWarehouse)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _cache[97] || (_cache[97] = _createElementVNode("span", null, "Almoxarifado", -1)),
                            (_openBlock(), _createElementBlock("svg", _hoisted_52, [...(_cache[96] || (_cache[96] = [
                              _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                            ]))]))
                          ]),
                          _createElementVNode("nav", _hoisted_53, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/almoxarifado') && !_ctx.activePath.includes('avarias') && !_ctx.activePath.includes('importar') }]),
                              type: "button",
                              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.$emit('warehouse-stock')))
                            }, " Inventário ", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/almoxarifado/avarias') }]),
                              type: "button",
                              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.$emit('warehouse-avarias')))
                            }, " Avarias ", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/almoxarifado/importar-nf') }]),
                              type: "button",
                              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.$emit('warehouse-nfe-import')))
                            }, " Importar NF ", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activePath.startsWith('/maquinario-pesado') }]),
                              type: "button",
                              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.$emit('heavy-machinery')))
                            }, " Maquinário Pesado ", 2)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canManageOffice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _cache[99] || (_cache[99] = _createElementVNode("span", null, "Escritório", -1)),
                            (_openBlock(), _createElementBlock("svg", _hoisted_56, [...(_cache[98] || (_cache[98] = [
                              _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                            ]))]))
                          ]),
                          _createElementVNode("nav", _hoisted_57, [
                            _createElementVNode("button", {
                              class: "nav-link",
                              type: "button",
                              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.$emit('office-tab', 'fornecedores')))
                            }, " Fornecedores "),
                            _createElementVNode("button", {
                              class: "nav-link",
                              type: "button",
                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.$emit('office-tab', 'rc')))
                            }, " Req. de Compra "),
                            _createElementVNode("button", {
                              class: "nav-link",
                              type: "button",
                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.$emit('office-tab', 'oc')))
                            }, " Ordens de Compra "),
                            _createElementVNode("button", {
                              class: "nav-link",
                              type: "button",
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.$emit('office-tab', 'nf')))
                            }, " Notas Fiscais "),
                            _createElementVNode("button", {
                              class: "nav-link",
                              type: "button",
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.$emit('office-tab', 'cc')))
                            }, " Centro de Custo "),
                            _createElementVNode("button", {
                              class: "nav-link",
                              type: "button",
                              onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.$emit('office-tab', 'questionarios')))
                            }, " Questionários "),
                            _createElementVNode("button", {
                              class: "nav-link",
                              type: "button",
                              onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.$emit('office-tab', 'gerencia')))
                            }, " Gerenciar Escritório ")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.adminMode && !_ctx.isAnalyst)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('nav.projects')), 1)
                    ]),
                    _createElementVNode("nav", _hoisted_60, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/meus-projetos' || _ctx.activePath === '/home' }]),
                        type: "button",
                        onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.$emit('my-projects')))
                      }, _toDisplayString(_ctx.$t('nav.myProjects')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/meus-relatorios' }]),
                        type: "button",
                        onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.$emit('filter', '')))
                      }, _toDisplayString(_ctx.$t('nav.reports')), 3),
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: _ctx.activePath === '/desenhos' }]),
                        type: "button",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.$emit('drawings')))
                      }, _toDisplayString(_ctx.$t('nav.drawings')), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.canRequestWarehouse && !_ctx.adminMode && !_ctx.isAnalyst)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 6,
                    class: _normalizeClass(["nav-group-header nav-group-link", { active: _ctx.activePath.startsWith('/almoxarifado/solicitar-item') }]),
                    type: "button",
                    onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.$emit('warehouse-request-item')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('nav.requestItem')), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (!_ctx.adminMode && !_ctx.isAnalyst && _ctx.showTickets)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 7,
                    class: _normalizeClass(["nav-group-header nav-group-link", { active: _ctx.activePath.startsWith('/chamados') }]),
                    type: "button",
                    onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.$emit('tickets')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('nav.tickets')), 1),
                    (_ctx.ticketPendingCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.ticketBadgeText), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_62, [
      (_ctx.showModeMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "mode-menu-backdrop",
            onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.showModeMenu = false))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.userName), 1),
      _createElementVNode("button", {
        class: "msg-btn",
        type: "button",
        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.$emit('messenger')))
      }, [
        _cache[100] || (_cache[100] = _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" })
        ], -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.messages')) + " ", 1),
        (_ctx.messengerUnread > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.messengerUnread > 9 ? '+9' : _ctx.messengerUnread), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showModeMenu && !_ctx.isAnalyst)
        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
            _cache[119] || (_cache[119] = _createElementVNode("div", { class: "mode-menu-label" }, "Selecionar sistema", -1)),
            (_ctx.canManageConstruction)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["mode-option", { active: !_ctx.maintenanceMode && !_ctx.adminMode && !_ctx.warehouseMode && !_ctx.officeMode && !_ctx.portariaMode }]),
                  type: "button",
                  onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.setMode('construcao')))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_66, [...(_cache[101] || (_cache[101] = [
                    _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" }, null, -1),
                    _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" }, null, -1)
                  ]))])),
                  _cache[103] || (_cache[103] = _createTextVNode(" Construção ", -1)),
                  (!_ctx.maintenanceMode && !_ctx.adminMode && !_ctx.warehouseMode && !_ctx.officeMode && !_ctx.portariaMode)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_67, [...(_cache[102] || (_cache[102] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.canManageMaintenance)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: _normalizeClass(["mode-option mode-option--maint", { active: _ctx.maintenanceMode }]),
                  type: "button",
                  onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.setMode('manutencao')))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_68, [...(_cache[104] || (_cache[104] = [
                    _createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" }, null, -1)
                  ]))])),
                  _cache[106] || (_cache[106] = _createTextVNode(" Manutenção ", -1)),
                  (_ctx.maintenanceMode)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_69, [...(_cache[105] || (_cache[105] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.canManageWarehouse)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: _normalizeClass(["mode-option mode-option--warehouse", { active: _ctx.warehouseMode }]),
                  type: "button",
                  onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.setMode('almoxarifado')))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_70, [...(_cache[107] || (_cache[107] = [
                    _createElementVNode("path", { d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" }, null, -1)
                  ]))])),
                  _cache[109] || (_cache[109] = _createTextVNode(" Almoxarifado ", -1)),
                  (_ctx.warehouseMode)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_71, [...(_cache[108] || (_cache[108] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.canManageOffice)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: _normalizeClass(["mode-option mode-option--office", { active: _ctx.officeMode }]),
                  type: "button",
                  onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.setMode('escritorio')))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_72, [...(_cache[110] || (_cache[110] = [
                    _createElementVNode("rect", {
                      x: "2",
                      y: "7",
                      width: "20",
                      height: "14",
                      rx: "2"
                    }, null, -1),
                    _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }, null, -1)
                  ]))])),
                  _cache[112] || (_cache[112] = _createTextVNode(" Escritório ", -1)),
                  (_ctx.officeMode)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_73, [...(_cache[111] || (_cache[111] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.canManagePortaria)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  class: _normalizeClass(["mode-option mode-option--portaria", { active: _ctx.portariaMode }]),
                  type: "button",
                  onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.setMode('portaria')))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_74, [...(_cache[113] || (_cache[113] = [
                    _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" }, null, -1),
                    _createElementVNode("path", { d: "M9 22V12h6v10" }, null, -1)
                  ]))])),
                  _cache[115] || (_cache[115] = _createTextVNode(" Portaria ", -1)),
                  (_ctx.portariaMode)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_75, [...(_cache[114] || (_cache[114] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  class: _normalizeClass(["mode-option mode-option--admin", { active: !_ctx.maintenanceMode && _ctx.adminMode && !_ctx.warehouseMode && !_ctx.officeMode && !_ctx.portariaMode }]),
                  type: "button",
                  onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.setMode('admin')))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_76, [...(_cache[116] || (_cache[116] = [
                    _createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }, null, -1)
                  ]))])),
                  _cache[118] || (_cache[118] = _createTextVNode(" Administrador ", -1)),
                  (!_ctx.maintenanceMode && _ctx.adminMode && !_ctx.warehouseMode && !_ctx.officeMode && !_ctx.portariaMode)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_77, [...(_cache[117] || (_cache[117] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isAnalyst)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass(["change-system-btn", { 'change-system-btn--maint': _ctx.maintenanceMode, 'change-system-btn--warehouse': _ctx.warehouseMode, 'change-system-btn--office': _ctx.officeMode, 'change-system-btn--portaria': _ctx.portariaMode, 'change-system-btn--admin': _ctx.adminMode && !_ctx.maintenanceMode && !_ctx.warehouseMode && !_ctx.officeMode && !_ctx.portariaMode, 'change-system-btn--open': _ctx.showModeMenu }]),
            type: "button",
            onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.showModeMenu = !_ctx.showModeMenu))
          }, [
            (_ctx.maintenanceMode)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_78, [...(_cache[120] || (_cache[120] = [
                  _createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" }, null, -1)
                ]))]))
              : (_ctx.warehouseMode)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_79, [...(_cache[121] || (_cache[121] = [
                    _createElementVNode("path", { d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" }, null, -1)
                  ]))]))
                : (_ctx.officeMode)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_80, [...(_cache[122] || (_cache[122] = [
                      _createElementVNode("rect", {
                        x: "2",
                        y: "7",
                        width: "20",
                        height: "14",
                        rx: "2"
                      }, null, -1),
                      _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }, null, -1)
                    ]))]))
                  : (_ctx.portariaMode)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_81, [...(_cache[123] || (_cache[123] = [
                        _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" }, null, -1),
                        _createElementVNode("path", { d: "M9 22V12h6v10" }, null, -1)
                      ]))]))
                    : (_ctx.adminMode)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_82, [...(_cache[124] || (_cache[124] = [
                          _createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_83, [...(_cache[125] || (_cache[125] = [
                          _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" }, null, -1),
                          _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" }, null, -1)
                        ]))])),
            _createTextVNode(" " + _toDisplayString(_ctx.modeLabelText) + " ", 1),
            (_openBlock(), _createElementBlock("svg", _hoisted_84, [...(_cache[126] || (_cache[126] = [
              _createElementVNode("polyline", { points: "18 15 12 9 6 15" }, null, -1)
            ]))]))
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.isAnalyst)
        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
            _cache[127] || (_cache[127] = _createElementVNode("svg", {
              width: "11",
              height: "11",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("circle", {
                cx: "11",
                cy: "11",
                r: "8"
              }),
              _createElementVNode("line", {
                x1: "21",
                y1: "21",
                x2: "16.65",
                y2: "16.65"
              })
            ], -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.analystMode')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_AppFooter, { class: "sidebar-footer" })
    ])
  ]))
}